export default "__VITE_ASSET__DnjAREED__"